import { Thread } from '@loctypes'

class ThreadModel {
  private readonly _data: Thread

  constructor(data: Thread) {
    this._data = data
  }

  get id(): string {
    return this._data._id
  }

  get name(): string {
    return this._data.name
  }

  get type(): Thread['type'] {
    return this._data.type
  }

  get channel(): Thread['channel'] {
    return this._data.channel
  }

  get isDefault(): Thread['isDefault'] {
    return Boolean(this._data.isDefault)
  }

  get transferId(): Thread['transferId'] {
    return this._data.transferId
  }

  getLocalizationName(language: string): string {
    if (Array.isArray(this._data.languages) && this._data.languages.length) {
      const accordingLanguage = this._data.languages.find((item) => item.language === language)

      if (accordingLanguage) {
        return accordingLanguage.name
      }
    }

    return this._data.name
  }
}

export default ThreadModel
